import { render, staticRenderFns } from "./BudgetSliderLegend.vue?vue&type=template&id=979e720a&scoped=true&"
var script = {}
import style0 from "./BudgetSliderLegend.vue?vue&type=style&index=0&id=979e720a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979e720a",
  null
  
)

export default component.exports